export default __webpack_public_path__ + "static/media/991.423485bb.png";